import { Link as RRLink, type LinkProps } from "react-router"
import type { Route } from "../react-router/routes.ts"

export const Link = (props: Link.Props) => {
  return <RRLink viewTransition {...props} />
}

namespace Link {
  export type Props = Omit<LinkProps, "to"> & {
    to: Route
  }
}
